import { Component, Input } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { ComponentPortal } from '@angular/cdk/portal';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { Clipboard } from '@angular/cdk/clipboard';
import { CreateTagComponent } from '../tags/create-tag/create-tag.component';
import { TransferServiceService } from '../transferService/transfer-service.service';
import { DataService } from '../data/data.service';
import { AssetsService } from 'app/assets/service/assets.service';
import { ModelsService } from './../../models/services/models.service';
import { RouteNavLockService } from 'app/services/route-nav-lock.service';
import { TagsService } from 'app/shared/services/tags.service';
import { ComponentsService } from './../../components/services/components.service';
import { UserManagementService } from 'app/user-management/user-management.service';
import { PanelService } from '../panels/chart/Services/panel.service';
import { RestAPIService } from 'app/services/rest-api.service';
import { PropertyService } from '../services/property.service';
import { DynamicDrawerService } from '../dynamic-drawer.service';
import { DynamicDrawerOptions } from '../dynamic-drawer-options';
import { EAggregationsTabs, EEntityTypes, RestRequestType } from 'app/shared/enums';
import { ModelDetails } from 'app/models/interfaces/model';

export interface DataIFace extends DynamicDrawerOptions {
  name: string;
  age: number;
}

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})

export class ButtonComponent implements ICellRendererAngularComp {
  @Input() data: DataIFace;
  public params: ICellRendererParams;
  agRowData: any;
  columnDefsDashboards: any;
  isAssetTagGrid: boolean = false;
  copiedStatus: boolean = false;

  constructor(
    public readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly clipboard: Clipboard,
    private readonly transferService: TransferServiceService,
    private readonly componentsService: ComponentsService,
    private readonly tagsService: TagsService,
    private readonly restApiService: RestAPIService,
    private readonly panelService: PanelService,
    private readonly modelsService: ModelsService,
    private readonly userManagementService: UserManagementService,
    private readonly assetsService: AssetsService,
    private readonly promptService: RouteNavLockService,
    private readonly dynamicDrawerService: DynamicDrawerService<DataIFace>,
    private readonly dataService: DataService,
    private readonly propertyService: PropertyService) {}

  agInit(params): void {
    if (params?.colDef?.meta?.entityType === "models" && params?.colDef?.meta?.type === "properties") {
      if (!params?.data?.componentInstanceName) {
        params.data.disableDeleteAction = false
      }
    }

    this.params = params;
    this.agRowData = params.node.data;
    this.isAssetTagGrid = params.colDef?.meta === 'asset-tag-grid' ? true : false;
  }

  get iconType() {
    if (this.params.colDef.hasOwnProperty('meta')) {
      return this.params.colDef['meta']?.iconType || '';
    }

    return '';
  }

  //#region refresh, viewRowData, onCopy and triggerParent methods

  /**
   * refresh
   * @param params params
   */
    refresh(params: ICellRendererParams): boolean {
      this.params = params;
      return true;
    }

    /**
     * view row data
     * @param params params
     */
    viewRowData(params) {
      console.log('params:123123 ', params);
      // this.router.routeReuseStrategy.shouldReuseRoute = function () {
      //   return false;
      // };
      // this.router.onSameUrlNavigation = 'reload';
      console.log(params);

      const currentUrl = this.router.url;

      switch (currentUrl) {
        case '/components':
          this.router.navigate(['/components/edit'], {
            relativeTo: this.route,
            queryParams: { 'id': this.agRowData.id }
          });
          break;
        case '/models':
          this.router.navigate(['/models/edit'], {
            relativeTo: this.route,
            queryParams: { 'id': this.agRowData.id }
          });
          break;
        case '/assets':
          this.router.navigate(['/assets/edit'], {
            relativeTo: this.route,
            queryParams: { 'id': this.agRowData.id }
          });
          break;
        case '/user-management/users':
          this.router.navigate(['edit'], {
            relativeTo: this.route,
            queryParams: { 'id': this.agRowData.id, 'isViewOnly': true }
          });
          break;
        case '/user-management/roles':
          this.router.navigate(['edit'], {
            relativeTo: this.route,
            queryParams: { 'name': this.agRowData.name, 'isViewOnly': true }
          });
          break;
        case '/user-management/usergroups':
          this.router.navigate(['edit'], {
            relativeTo: this.route,
            queryParams: { 'id': this.agRowData.id, 'isViewOnly': true }
          });
          break;
        case '/user-management/features':
          this.router.navigate(['edit'], {
            relativeTo: this.route,
            queryParams: { 'name': this.agRowData.name, 'isViewOnly': true }
          });
          break;
          case '/settings/dropdowns':

            break;
        // component -> aggregations Tab
        case '/components/edit?id=' + `${this.route.snapshot.queryParamMap.get('id')}`: case '/models/edit?id=' + `${this.route.snapshot.queryParamMap.get('id')}`:
          if (params.colDef?.meta === 'time-aggregation') {
            params.context?.parentComponent?.viewAggregation(EAggregationsTabs.Aggregation, true, params.data);
          }
          break;

        default:
          this.dynamicDrawerService.open(new ComponentPortal(CreateTagComponent));
          this.transferService.setData(this.agRowData);
          break;
      }
    }

    /**
     * on copy
     * @param params params
     */
    onCopy(params) {
      this.copiedStatus = true;
      this.clipboard.copy(`${this.route.snapshot.queryParamMap.get('id')}.${params.data.componentInstanceId ? params.data.componentInstanceId : ''}.${params.data.id}`);
      setTimeout(() => { this.copiedStatus = false }, 3000);
    }

    /**
     * trigger parant
     * @param params params
     */
    triggerParent(params) {
      if (params.context?.parentComponent) {
        params.context.parentComponent.treeActionTriggered(params.data);
      }
    }

    //#endregion

  //#region add alarm and add subscription methods

  /**
   * add Alarm
   * @param params params
   */
  addAlarm(params: ICellRendererParams) {
    if (params.context?.parentComponent) {
      params.context?.parentComponent.addAlarm(params.data);
    }
  }

  /**
   * add Subscription
   * @param params params
   */
  addSubscription(params: ICellRendererParams) {
    if (params.context?.parentComponent) {
      this.dataService.selectedAlarm.next(params?.data);
      params.context?.parentComponent.addSubscription(params.data);
    }
  }

  //#endregion

  //#region delete row action

  /**
   * delete row data from grid
   * @param params grid params
   */
  deleteRowData(params) {
    const currentUrl = this.router.url;
    const selectedRow = [params.data];

    switch (currentUrl) {
      case '/components':
        const sub = this.promptService.showRouteNavPrompt(`Warning, deleting component '${params.data.name}' is irrereversable, are you sure you want to proceed?`)
          .subscribe(res => {
            sub.unsubscribe();
            if (res) {
              this.componentsService.deleteComponent(params.data.id)
                .then(result => {
                  this.params.api.applyTransaction({ remove: selectedRow });
                });
            }
          });
        break;

      case '/models':
        const subModel = this.promptService.showRouteNavPrompt(`Warning, deleting model '${params.data.name}' is irrereversable, are you sure you want to proceed?`)
          .subscribe(res => {
            subModel.unsubscribe();
            if (res) {
              this.modelsService.deleteModel(params.data.id)
                .then(result => {
                  this.params.api.applyTransaction({ remove: selectedRow });
                  const updatedModels: ModelDetails[] = this.modelsService._modelsSource.getValue().filter(model => model.id !== params.data.id);
                  this.params.context.componentParent.setRows([...updatedModels]);
                });
            }
          });
        break;
      case '/assets':
        const defaultMessage: string = `Warning! All data associated with asset "${params?.data?.name}" will be permanently deleted, and can’t be recovered. To proceed with the delete, please enter your credentials.`;
        this.promptService.showRouteNavPromptWithCredentials(defaultMessage, EEntityTypes.ASSETS).pipe(take(1))
          .subscribe((res) => {
            if (res) {
              // console.log('res :>> ', res);
              this.assetsService.deleteAsset(params.data.id, res).pipe(take(1)).subscribe(res => {
                this.params.api.applyTransaction({ remove: selectedRow });
              }); // subscribe able
            }
          });
        break;
      case '/user-management/users':
        const subUser = this.promptService.showRouteNavPrompt('This action is irreversible!')
          .subscribe(res => {
            subUser.unsubscribe();
            if (res) {
              this.userManagementService.deleteUserById(params.data.id).then(result => {
                params.context.parentComponent.triggerDeleteAction(params.data);
                this.params.api.applyTransaction({ remove: selectedRow });
              });
            }
          });
        break;
      case '/user-management/roles':
        const subRole = this.promptService.showRouteNavPrompt('This action is irreversible!')
          .subscribe(res => {
            subRole.unsubscribe();
            if (res) {
              const body = { name: params.data.name };
              const payload = this.restApiService.buildPayload(body, RestRequestType.DELETE_ROLE);
              this.userManagementService.deleteRole(payload).then(result => {
                params.context.parentComponent.triggerDeleteAction(params.data);
                this.params.api.applyTransaction({ remove: selectedRow });
              });
            }
          });
        break;
      case '/user-management/usergroups':
        const group = this.promptService.showRouteNavPrompt('This action is irreversible!')
          .subscribe(res => {
            group.unsubscribe();
            if (res) {
              this.userManagementService.deleteUserGroupById(params.data.id).then(result => {
                params.context.parentComponent.triggerDeleteAction(params.data);
                this.params.api.applyTransaction({ remove: selectedRow });
              });
            }
          });
        break;
      case '/user-management/features':
        const feature = this.promptService.showRouteNavPrompt('This action is irreversible!')
          .subscribe(res => {
            feature.unsubscribe();
            if (res) {
              const body = { name: params.data.name };
              const payload = this.restApiService.buildPayload(body, RestRequestType.DELETE_FEATURE);
              this.userManagementService.deleteFeature(payload).then(result => {
                this.params.api.applyTransaction({ remove: selectedRow });
              });
            }
          });
        break;
      default:
        // console.log('assets default:>> ');
        if (params.colDef.hasOwnProperty('meta')) {
          this.metaDeleteAction(params.colDef.meta, selectedRow, params.data, params);
          return;
        }
        this.deleteAction(params, selectedRow);
        // this.params.api.applyTransaction({ remove: selectedRow }); ////////////////////
        break;
    }
  }

  /**
   * delete with meta data
   * @param meta meta data
   * @param selectedRow selected row
   * @param data data
   * @param params params
   */
  metaDeleteAction(meta: any, selectedRow: any, data, params) {
    let showmsg: string = "This action is irreversible!";
    if ((meta.entityType === 'models' && meta.type === "properties") || (meta.entityType === "components" && meta.type === "properties")) {
      showmsg = 'Any properties that were overridden on any asset will also be deleted'
    }

    this.promptService.showRouteNavPrompt(showmsg)
      .subscribe(res => {
        if (res) {
          if (meta.type === 'properties') {
            this.propertyService.deleteProperty(data.entityType, data.entityId, meta.type, data.id);
          } else if (meta.type === 'dashboards') {
            this.panelService.deleteDashboard(params.data.id).then(() => {
              const index: number = meta.dashboardNames?.findIndex(name => (name === data.name));
              meta.dashboardNames.splice(index, 1);
              params.context.parentComponent.triggerDeleteAction(params.data);
              this.params.api.applyTransaction({ remove: selectedRow });
            });
          }
          else if (params.context?.parentComponent?.triggerDeleteAction) {
            params.context.parentComponent.triggerDeleteAction(params.data);
          } else {
            this.tagsService.deleteTag(meta.entityType, data.entity_id, meta.type, data.id)
              .then(() => {
                this.params.api.applyTransaction({ remove: selectedRow });
              });
          }
        }
      });
  }

  /**
   * delete action
   * @param params params
   * @param selectedRow selected row
   */
  deleteAction(params: ICellRendererParams, selectedRow?: any) {
    this.promptService.showRouteNavPrompt('This action is irreversible!')
      .subscribe(res => {
        if (res && params.context?.parentComponent?.triggerDeleteAction) {
          params.context.parentComponent.triggerDeleteAction(params.data);
          this.params.api.applyTransaction({ remove: selectedRow }); // newly added for delete subscription
        }
      });
  }

  //#endregion

}
